import React from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { ReservationPolicy } from '../../../api/services/next';

const ReservationPoliciesDropDown = ({ ...props }) => {
  return (
    <DropDown
      search={false}
      api={ReservationPolicy.GetReservationPolicies}
      textField='Name'
      valueField='Id'
      {...props}
    />
  );
};

ReservationPoliciesDropDown.propTypes = {
  HotelChainId: PropTypes.any,
};

export default ReservationPoliciesDropDown;
